import { Injectable, signal } from "@angular/core";
import { SectionGroupId } from "./pricing-sections";

@Injectable()
export class EnrichmentPricingGroupStore {
  private readonly group = signal<SectionGroupId>("content");
  readonly activeGroup = this.group.asReadonly();

  select(id: SectionGroupId): void {
    this.group.set(id);
  }
}
